import styled from "styled-components";

import Heading from "core/Heading";
import BodyText from "core/BodyText";
import { BorderBottomLinkStyle } from "core/Typography";

import { convertPxToRem } from "frontend/components/helpers";

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const IconContainer = styled.div`
    margin-right: ${convertPxToRem({ px: 8 })};
`;

export const TextContainer = styled.div``;

export const StyledHeading = styled(Heading)`
    margin-bottom: ${convertPxToRem({ px: 4 })};
`;

export const StyledBodyText = styled(BodyText)`
    a {
        ${BorderBottomLinkStyle}
        padding-bottom: ${convertPxToRem({ px: 1 })};
    }
`;
